import { Button } from "@mui/material";
import { Run } from "../../../services/appsync/types";
import { useMemo } from "react";

export const StartRunButtonComponent = ({
  engineInProgress,
  runInProgress,
  onClick,
  loading,
}: {
  engineInProgress: boolean;
  runInProgress: Run | null;
  onClick: () => void;
  loading: boolean;
}) => {
  const buttonLabel = useMemo(() => {
    if (engineInProgress && runInProgress) {
      if (runInProgress?.runSettings.workflowId === "workflow_atomic_pivots") {
        return `Running ... ${runInProgress?.atStep! / runInProgress?.totalSteps! ? `${Math.round((runInProgress?.atStep! / runInProgress?.totalSteps!) * 100)}%` : ""}`;
      } else if (
        runInProgress?.runSettings.workflowId === "google_drive_sync"
      ) {
        return `Data sync ...`;
      }
    }
    return "Start Run";
  }, [engineInProgress, runInProgress]);
  return (
    <Button
      variant={engineInProgress ? "outlined" : "contained"}
      onClick={onClick}
      disabled={engineInProgress || loading}
      loading={engineInProgress}
      loadingPosition="end"
      sx={{
        mr: 1,
        height: 34,
        fontSize: "12.5px",
        fontWeight: 600,
        // Keep the label sentence-case ("Start Run"); MUI's Button theme
        // uppercases by default.
        textTransform: "none",
        borderRadius: "6px",
        padding: "0 14px",
        backgroundColor: (t) =>
          engineInProgress ? undefined : t.palette.atomic.brandBlue,
        color: engineInProgress ? undefined : "#fff",
        "&:hover": {
          backgroundColor: (t) =>
            engineInProgress ? undefined : t.palette.atomic.brandBlueDark,
        },
      }}
    >
      {buttonLabel}
    </Button>
  );
};
